import React, { useState, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import AboutMe from './components/AboutMe';
import PipelineBackground from './components/PipelineBackground';
import DevToolsToggle from './components/DevToolsToggle';
import './App.css';

const Blog = lazy(() => import('./components/Blog'));
const Gallery = lazy(() => import('./components/Gallery'));
const Contact = lazy(() => import('./components/Contact'));
const Projects = lazy(() => import('./components/Projects'));
const DevTools = lazy(() => import('./components/DevTools'));

const PageLoader = () => (
  <div className="flex justify-center items-center min-h-[200px]">
    <div className="w-8 h-8 border-[3px] border-gray-dark rounded-full border-t-gold animate-spin"></div>
  </div>
);

function App() {
  const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);

  return (
    <Router>
      <PipelineBackground />

      <Header />
      <main id="main-content">
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/about" element={<AboutMe />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/photos" element={<Gallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<Blog />} />
            <Route path="/post/:id" element={<Blog />} />
            <Route path="/posts/:id" element={<Blog />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/" element={<AboutMe />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />

      <DevToolsToggle
        isOpen={isDevToolsOpen}
        onToggle={() => setIsDevToolsOpen(prev => !prev)}
      />

      {isDevToolsOpen && (
        <Suspense fallback={null}>
          <DevTools isOpen={isDevToolsOpen} onClose={() => setIsDevToolsOpen(false)} />
        </Suspense>
      )}
    </Router>
  );
}

export default App;